module.exports = __webpack_public_path__ + "static/media/research-maximise-data-validity.56075dd8.png";